<template>
  <div class="pagination mt-10" style="margin-top:24px;color: #606266;font-size:14px">
    <button :class="['turn', {'turnTo':turnLeft}]" :disabled="turnLeft" @click="last"><i class="el-icon el-icon-arrow-left"></i></button>
    <div class="ml-10 mr-10">{{pageNum}}/{{pageCount}}</div>
    <button :class="['turn', {'turnTo':turnRight}]" :disabled="turnRight" @click="next"><i class="el-icon el-icon-arrow-right"></i></button>
  </div>
</template>

<script>
export default {
  name: 'paginationSimple',
  props: {
    pageSize: {
      type: Number,
      default: 10
    },
    pageNum: {
      type: Number,
      default: 1
    },
    total: {
      type: Number,
      default: 0
    }
  },
  computed: {
    pageCount() {
      return Math.ceil(this.total / this.pageSize)
    },
    turnLeft() {
      if (this.pageNum - 1 <= 0) {
        return true
      }
      return false
    },
    turnRight() {
      if (this.pageNum + 1 > this.pageCount) {
        return true
      }
      return false
    },
  },
  methods: {
    last() {
      this.$emit('currentChange', this.pageNum - 1)
    },
    next() {
      this.$emit('currentChange', this.pageNum + 1)
    }
  }
}
</script>

<style lang='scss' rel='stylesheet/scss' scoped>
.pagination {
  display: inline-block;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .turn {
    // border: 1px solid #d9d9d9;
    border-radius: 3px;
    cursor: pointer;
    // padding: 3px;
    &.turnTo {
      cursor: no-drop;
    }
  }
}
</style>
